import { useI18n } from "@/lib/i18n";

const NL = [
  ["1. Toepassingsbereik", "Deze algemene voorwaarden gelden voor iedere bestelling gedaan via peptivance.eu. Door een bestelling te plaatsen accepteert de koper deze voorwaarden."],
  ["2. Bestellen en betaling", "Bestellingen worden geplaatst via de webshop. Betaling verloopt via Stripe (creditcard, iDEAL, Klarna, PayPal, SEPA). De koopovereenkomst komt tot stand na succesvolle betaling."],
  ["3. Verzending", "Bestellingen geplaatst vóór 15:00 CET worden dezelfde werkdag verzonden. Verzendtijden: NL 1–2 werkdagen, EU 2–5 werkdagen. Verzending is voor risico van de koper zodra het pakket door de vervoerder is opgehaald."],
  ["4. Prijzen", "Alle op de website vermelde prijzen zijn in Euro (EUR) en inclusief BTW. Verzendkosten worden apart weergegeven bij checkout. Bestellingen boven €200 worden gratis verzonden binnen de EU."],
  ["5. Retour", "Vanwege de aard van steriele farmaceutische onderzoeksmaterialen kunnen geopende flacons niet worden geretourneerd. Beschadigde zendingen worden binnen 7 dagen na ontvangst gemeld en gratis vervangen."],
  ["6. Aansprakelijkheid", "Peptivance is uitsluitend aansprakelijk voor directe schade tot maximaal het factuurbedrag. Indirecte schade, gevolgschade en gebruik buiten de onderzoekscontext vallen buiten deze aansprakelijkheid."],
  ["7. Toepasselijk recht", "Op deze voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland."],
];

const EN = [
  ["1. Scope", "These terms apply to every order placed via peptivance.eu. By placing an order the buyer accepts these terms."],
  ["2. Orders and payment", "Orders are placed via the web store. Payment is processed via Stripe (credit card, iDEAL, Klarna, PayPal, SEPA). The purchase agreement comes into effect upon successful payment."],
  ["3. Shipping", "Orders placed before 3PM CET are dispatched the same working day. Shipping times: NL 1–2 business days, EU 2–5 business days. Risk of loss transfers upon carrier handover."],
  ["4. Pricing", "All prices on the website are in Euro (EUR) and include VAT. Shipping costs are shown separately at checkout. Orders above €200 ship free within the EU."],
  ["5. Returns", "Due to the nature of sterile pharmaceutical research materials, opened vials cannot be returned. Damaged shipments must be reported within 7 days of receipt and will be replaced free of charge."],
  ["6. Liability", "Peptivance is only liable for direct damage up to the invoice amount. Indirect damage, consequential damage and use outside the research context are excluded."],
  ["7. Governing law", "These terms are governed by Dutch law. Disputes will be submitted to the competent court in the Netherlands."],
];

export default function Terms() {
  const { lang } = useI18n();
  const items = lang === "nl" ? NL : EN;
  return (
    <div data-testid="terms-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ LEGAL / TERMS ]</p>
        <h1 className="font-serif-display font-light text-5xl md:text-7xl leading-[0.98] mb-16">
          {lang === "nl" ? "Algemene voorwaarden" : "Terms & conditions"}
        </h1>
        <div className="border-t border-neutral-300">
          {items.map(([title, body], i) => (
            <div key={i} className="border-b border-neutral-300 py-10 grid md:grid-cols-12 gap-8">
              <div className="md:col-span-1 font-mono-label text-[10px] text-neutral-500">0{i + 1}</div>
              <div className="md:col-span-4">
                <h2 className="font-serif-display text-2xl md:text-3xl leading-tight">{title}</h2>
              </div>
              <div className="md:col-span-7">
                <p className="text-neutral-600 leading-relaxed">{body}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-16 font-mono-label text-[10px] text-neutral-500">
          Last updated: {new Date().toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB")}
        </p>
      </div>
    </div>
  );
}
